// Shared markdown-it `link_open` renderer rule, extracted from libs/markdown.js
// so every markdown instance in the app handles links identically:
// - absolute http(s) links open in a new tab (target="_blank");
// - cross-origin non-image links are rewritten to the in-app /link redirect
//   page (carrying data-md-link="open") so the backend jump whitelist and the
//   leave-site confirmation page apply. Inside an iframe the original href is
//   kept and the host page handles the click via the data-md-link marker.

const IMAGE_URL_RE = /\.(png|jpe?g|gif|svg|webp|bmp|ico|avif|apng)(\?.*)?$/i;

function isImageUrl(href) {
  if (!href) return false;
  try {
    return IMAGE_URL_RE.test(new URL(href).pathname);
  } catch {
    return IMAGE_URL_RE.test(href.split('?')[0]);
  }
}

function parseAbsoluteHttpUrl(href) {
  if (!href || !/^https?:\/\//i.test(href)) return null;
  try {
    const url = new URL(href);
    if (
      (url.protocol !== 'http:' && url.protocol !== 'https:') ||
      !url.hostname
    ) {
      return null;
    }
    return url;
  } catch {
    return null;
  }
}

const renderTokenDefault = (tokens, idx, options, env, self) => {
  return self.renderToken(tokens, idx, options);
};

export const applyExternalLinkOpenRule = md => {
  const defaultRender = md.renderer.rules.link_open || renderTokenDefault;
  md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    const href = tokens[idx].attrGet('href');
    const isInIframe = window.self !== window.top;
    const urlObj = parseAbsoluteHttpUrl(href);
    if (urlObj) {
      const { origin } = window.location;
      tokens[idx].attrPush(['target', '_blank']);
      if (urlObj.origin !== origin && !isImageUrl(href)) {
        const h = encodeURIComponent(href);
        tokens[idx].attrSet('data-md-link', 'open');
        if (isInIframe) {
          tokens[idx].attrSet('href', href);
        } else {
          tokens[idx].attrSet('href', `/link?target=${h}`);
        }
      }
    }

    return defaultRender(tokens, idx, options, env, self);
  };
};
